import axios from "axios";
import { API_BASE_URL } from "../utils/constants";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const request = async (endpoint, method = "GET", data = null, config = {}) => {
  try {
    const token = localStorage.getItem("token");

    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common["Authorization"];
    }

    const response = await api({
      url: endpoint,
      method,
      data,
      withCredentials: false,
      ...config
    });

    return { data: response.data, token: response.data?.access_token };
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const get = (endpoint, config = {}) => request(endpoint, "GET", null, config);
export const post = (endpoint, data, config = {}) => request(endpoint, "POST", data, config);
export const put = (endpoint, data, config = {}) => request(endpoint, "PUT", data, config);
export const patch = (endpoint, data, config = {}) => request(endpoint, "PATCH", data, config);
export const del = (endpoint, config = {}) => request(endpoint, "DELETE", {}, config);
